import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from '../../../business/misc/impressum/async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default (
  <Route
    key="/consumer/impressum"
    element={
      <DefaultConsumerLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Consumer',
            item: '/consumer',
          },
          {
            position: 3,
            name: 'Impressum',
            item: '/consumer/impressum',
          },
        ]}
      />
    }
  >
    <Route path="consumer/impressum" element={<AsyncPage />} />
  </Route>
);
